import {
    LOGIN_POST_ERROR,
    LOGIN_POST_REQUESTING,
    LOGIN_POST_SUCCESS
} from "./constants";

const initialState = {
    requesting: false,
    success: false,
    error: '',
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_POST_REQUESTING:
            return {
                ...state,
                requesting: true,
                success: false,
                error: '',
            };
        case LOGIN_POST_SUCCESS:
            return {
                requesting: false,
                success: true,
            };
        case LOGIN_POST_ERROR:
            return {
                ...state,
                requesting: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default reducer;